import styled from 'styled-components';
import { baseVariables } from '@marriott/mi-ui-library';

const { color } = baseVariables;

export const StyledInlineMessages = styled.div`
  a {
    color: ${color.bvyAccent20};
  }
`;
